import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import Button from './button';
import LoadingSpinner from './shared/loading-spinner';
var LoadingButton = /*#__PURE__*/React.forwardRef(function LoadingButton(_ref, ref) {
  var _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      rest = _objectWithoutProperties(_ref, ["isLoading"]);

  // Button already has React.memo, so just leaning on that
  return /*#__PURE__*/React.createElement(Button, _extends({}, rest, {
    ref: ref,
    overlay: isLoading ? /*#__PURE__*/React.createElement(LoadingSpinner, rest) : null
  }));
}); // Tools including enzyme rely on components having a display name

LoadingButton.displayName = 'LoadingButton';
export default LoadingButton;